import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  UntypedFormControl,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { jwtDecode } from 'jwt-decode';
import * as sha256 from 'crypto-js/sha256';

import { AuthService } from 'src/app/services/auth.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';

import { environment } from 'src/environments/environment';
import { User } from 'src/app/interfaces/user';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  recoverPasswordEmail = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
  ]);
  loginForm: UntypedFormGroup;
  credencialesInvalidas: boolean = false;
  passwordType: 'password' | 'text' = 'password';
  isPasswordType: boolean = true;
  isTablet: boolean = false;

  public environment = environment;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router,
    public route: ActivatedRoute,
    public storageService: StorageService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.min(6)]],
    });
  }

  ngOnInit(): void {
    if (this.route.snapshot.url[0].path === 'login-tablet') {
      this.isTablet = true;
    }
  }

  changePasswordType() {
    this.isPasswordType = !this.isPasswordType;
    this.isPasswordType
      ? (this.passwordType = 'password')
      : (this.passwordType = 'text');
  }

  onSubmit() {
    this.credencialesInvalidas = false;

    const hashPassword = sha256(this.password.value).toString().toUpperCase();

    const user = {
      email: this.email.value,
      password: hashPassword,
    };

    this.isTablet ? this.loginTablet(user) : this.loginWeb(user);
  }

  loginTablet(user: any) {
    this.authService.loginTablet(user).subscribe({
      next: (response: any) => {
        this.manageLoginResponse(response);
        this.router.navigate(['dashboard']);
        this.storageService.set('isTablet', 'true');
      },
      error: (error: HttpErrorResponse) => {
        this.manageLoginErrorResponse(error);
      },
    });
  }

  loginWeb(user: any) {
    this.authService.login(user).subscribe({
      next: (response: any) => {
        this.manageLoginResponse(response);
        this.router.navigate(['dashboard']);
        this.storageService.set('isTablet', 'false');
      },
      error: (error: HttpErrorResponse) => {
        this.manageLoginErrorResponse(error);
      },
    });
  }

  manageLoginResponse(response: any) {
    this.storageService.set('accessToken', response.accessToken);
    this.storageService.set('refreshToken', response.refreshToken);
    this.toastService.success('Iniciaste sesión con éxito.');
    this.storageService.set(
      'staffUser',
      JSON.stringify(jwtDecode(response.accessToken))
    );
  }

  manageLoginErrorResponse(error: HttpErrorResponse) {
    error.status == 400
      ? this.toastService.alert(
          'Credenciales invalidas. Revisa el email y la contraseña.'
        )
      : this.toastService.alert(
          'Un error inesperado ha ocurrido, si el error persiste comunicarse con el soporte.'
        );
  }

  get email() {
    return this.loginForm.controls['email'];
  }

  get password() {
    return this.loginForm.controls['password'];
  }
}
